import { ChevronsUpDownIcon, EllipsisVerticalIcon, EyeIcon } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuBasicTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

interface TraceTranscriptMessageActionsProps {
  align: "start" | "end";
  isJsonExpanded: boolean;
  isMessageExpanded: boolean;
  showMessageExpansionToggle: boolean;
  onToggleMessageExpansion: () => void;
  onToggleJson: () => void;
}

export const TraceTranscriptMessageActions = ({
  align,
  isJsonExpanded,
  isMessageExpanded,
  showMessageExpansionToggle,
  onToggleMessageExpansion,
  onToggleJson,
}: TraceTranscriptMessageActionsProps) => (
  <DropdownMenu>
    <DropdownMenuBasicTrigger
      className={cn(
        "flex h-6 w-6 items-center justify-center rounded-md",
        "text-gray-400 hover:bg-gray-200 hover:text-gray-600",
      )}
    >
      <EllipsisVerticalIcon className="h-4 w-4" />
    </DropdownMenuBasicTrigger>
    <DropdownMenuContent align={align} sideOffset={4} className="min-w-[140px]">
      <DropdownMenuItem
        onSelect={onToggleJson}
        className="flex w-full cursor-pointer items-center gap-2 text-sm"
      >
        <EyeIcon className="h-3.5 w-3.5" />
        <span>{isJsonExpanded ? "Hide JSON" : "View JSON"}</span>
      </DropdownMenuItem>
      {showMessageExpansionToggle ? (
        <DropdownMenuItem
          onSelect={onToggleMessageExpansion}
          className="flex w-full cursor-pointer items-center gap-2 text-sm"
        >
          <ChevronsUpDownIcon className="h-3.5 w-3.5" />
          <span>{isMessageExpanded ? "Collapse message" : "Expand message"}</span>
        </DropdownMenuItem>
      ) : null}
    </DropdownMenuContent>
  </DropdownMenu>
);
